/**
 * Get the base domain for district subdomains.
 * e.g. smartmarketing.backtoschool.smdemo.website -> backtoschool.smdemo.website
 *      backtoschool.smdemo.website -> backtoschool.smdemo.website
 */
export const getBaseDomain = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('localhost')) return 'backtoschool.smdemo.website'; // dev fallback
  const parts = hostname.split('.');
  if (parts.length >= 4) return parts.slice(1).join('.');
  return hostname;
};

/**
 * Build district URL for a given subdomain
 * e.g. getDistrictUrl('smartmarketing') -> https://smartmarketing.backtoschool.smdemo.website
 */
export const getDistrictUrl = (subdomain) => {
  const base = getBaseDomain();
  return `${window.location.protocol}//${subdomain}.${base}`;
};
